<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">
    <dx-load-panel #loadPanel shadingColor="rgba(231, 231, 231,0.4)" [position]="{ of: '#containerVacaciones' }"
      [visible]="loading" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
    </dx-load-panel>
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-12">
        <div class="row">
          <div class="col-md col-lg col-xl">
            <app-company-selector dataSize="7" placeHolder="Empresas" [(ngModel)]="selectedCompany"
              [required]="true" [onlyConfigured]="true" (selectedValueChange)="onCompanySelecteChanged()"></app-company-selector>
          </div>
          <!-- <div class="col-md col-lg col-xl">
            <app-year-selector dataSize="7" placeHolder="Ejercicio" [(selectedValue)]="selectedYear" [required]="true">
            </app-year-selector>
          </div> -->
          <!-- Botón de búsqueda -->
          <div class="col-md-auto col-lg-auto col-xl-auto">
            <button class="btn btn-fill btn-primary float-right" [disabled]="!selectedCompany"
              (click)="onSearch()">Buscar</button>
          </div>
        </div>
      </div>
    </div>

    <dx-data-grid #gridPersonas [dataSource]="empleados" [allowColumnResizing]="true"
      [columnResizingMode]="'widget'" (onEditorPreparing)="onEditorPreparing($event)">
      <dxo-selection [selectAllMode]="'allPages'" [showCheckBoxesMode]="'always'" mode="multiple"></dxo-selection>

      <!-- Definición de las columnas -->
      <dxi-column caption="Centro" alignment="center">
        <dxi-column dataField="A3LWorkplaceCode" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="A3LWorkplaceName" caption="Centro"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Imputación" alignment="center">
        <dxi-column dataField="A3LCostAttributionNodeCode" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="A3LCostAttributionNodeDescription" caption="Imputacion"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Trabajador" alignment="center">
        <dxi-column dataField="A3LEmployeeCode" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="A3LCompleteName" caption="Trabajador"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Cálculo bolsa" alignment="center">
        <dxi-column dataField="CalculationType" caption="Tipo" alignment="center"> </dxi-column>
      </dxi-column>
      <dxo-export [enabled]="true"></dxo-export>
    </dx-data-grid>

    <div class="row" style="margin-top: 20px;">
      <div class="col-4 ml-auto">
        <app-mat-select-filtered [items]="companySelectedAgreements" [valueColumn]="'Id'"
                [descriptionColumns]="['Descripcion']" [multiple]="false" [placeHolder]="'Convenios'"
                name="companySelectedAgreementValue" [emptyOption]="true" [ngModel]="companySelectedAgreementValue" (ngModelChange)="onSelectedAgreementsChanged($event)">
              </app-mat-select-filtered>
      </div>
      <div class="col-3">
        <app-mat-select-filtered [items]="calculos" [valueColumn]="'Id'"
          [descriptionColumns]="['Descripcion']" [multiple]="false" [emptyOption]="true" [placeHolder]="'Tipo cálculo'" [(ngModel)] = "calculoSeleccionado"
          name="selectedAgreements">
        </app-mat-select-filtered>
      </div>
      <div class="col-2">
        <div class="dx-field pl-auto pr-auto">
          <div class="dx-field-value">
            <dx-check-box [(value)]="clearValue" text="Limpiar valor"></dx-check-box>
          </div>
        </div>
      </div>
      <div class="col-auto">
        <button class="btn btn-fill btn-primary float-right" (click)="btnAsignarClick()" [disabled]="!companySelectedAgreementValue || !calculoSeleccionado">Asignar</button>
      </div>
    </div>
  </app-generic-panel>
  <br>
</app-generic-container>
